import { TwAutocompleteOption } from '../../../components/TwAutocomplete/TwAutocomplete';

export interface INamedCompanies {
  company: string;
  username?: string;
  password?: string;
  clientNo?: string;
}

export interface IOtherCompanies {
  company: string;
  company_email?: string | null;
  company_address?: string | null;
}

export interface OrderFactoredStatus {
  divisionId: string;
  orderId: string;
  status: string;
  factoring_status: string;
  updated_at: string;
  company: string;
  invoiceId: string;
}

export enum REQUIRED_FIELDS {
  USERNAME = 'username',
  PASSWORD = 'password',
  CLIENT_NO = 'clientNo'
}

export type RequiredFields = 'username' | 'password' | 'clientNo';

export interface IFactoringIntegrations {
  company: string;
  requiredFields: RequiredFields[];
}

export type FactoringOption = TwAutocompleteOption & { requiredFields: RequiredFields[] };
